export const SPORTS = {
  GameTimeOut:5000
}